import { Module } from 'vuex'
import { ProfileState } from './types'
import { RootState } from '@/Common/store/types'
import { actions } from './actions'
import { getters } from './getters'
import { mutations } from './mutations'
import { state } from './state'

const namespaced: boolean = true

export const profile: Module<ProfileState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations,
}
